import { z } from "zod"

const createTransferCostSchema = (label: string) =>
  z.number().min(0, `${label} must be greater than or equal to 0`).nullable()

export const transferLaidDownCostFormSchema = z.object({
  freightMiscCostPerUom: createTransferCostSchema("Freight & Misc. (per UoM)"),
  freightMiscCost: createTransferCostSchema("Freight & Misc. Total"),
  warehousingFees: createTransferCostSchema("Warehousing Fees"),
  monthlyStorageAccrual: createTransferCostSchema("Monthly Storage Accrual"),
  inboundHandlingCost: createTransferCostSchema("Inbound Handling Costs"),
  outboundHandlingCost: createTransferCostSchema("Outbound Handling Costs"),
  products: z.array(
    z.object({
      productId: z.number(),
      originalCostPerUom: createTransferCostSchema("Original Cost per UoM").refine(
        (value): boolean => value !== null,
        "Original Cost per UoM is required"
      ),
    })
  ),
  isCostComplete: z.boolean(),
})

export type TransferLaidDownCostFormValues = z.infer<typeof transferLaidDownCostFormSchema>
